module.exports = __webpack_public_path__ + "assets/403c9376f422627457c16100d2b5d3e7.png";